<script setup lang="ts">
  import ModalDialog from '@/VueComponents/Modals/ModalDialog.vue';

  const emit = defineEmits < { 'delete' }>();
  const visible = defineModel<boolean>({ default: false });

</script>

<template>
  <ModalDialog
    v-model="visible"
    :title="$localize('DeleteUploadFolder')"
    :is-danger="true"
  >
    <template #default>
      <div>
        {{ $localize('DeleteUploadFolderText') }}
      </div>
      <div class="mt-3">
        {{ $localize('DeleteUploadFolderQuestion') }}
      </div>
    </template>
    <template #footer>
      <button
        ref="closeBtn"
        class="btn btn-outline-secondary"
        @click="visible = false"
      >
        {{ $localize('Cancel') }}
      </button>
      <button
        ref="deleteBtn"
        class="btn btn-danger"
        @click="emit('delete')"
      >
        {{ $localize('Continue') }}
      </button>
    </template>
  </ModalDialog>
</template>
